

// use zod schema to extract fields from an object
import {ZodSchema} from "zod";

export function extractFieldsFromB<T>(objB: any, schema: ZodSchema): T {

    const schemaA: Record<string, any> = schema.shape;
    const result: Record<string, any> = {};

    for (const key in schemaA) {
        if (objB.hasOwnProperty(key)) {
            result[key] = objB[key];
        }
    }

    return result as T;
}